import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import * as types from '../constants/actionTypes';
import * as actions from '../actions/priceHistoryActions';
import { priceHistoryAPI } from '../../api/config';

function* fetchProductPriceHistorySaga(action) {
  try {
    const { productId, params } = action.payload;
    const response = yield call(priceHistoryAPI.getProductHistory, productId, params);
    yield put(actions.fetchProductPriceHistorySuccess(productId, response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch price history';
    yield put(actions.fetchProductPriceHistoryFailure(msg));
    message.error(msg);
  }
}

function* fetchVendorPriceHistorySaga(action) {
  try {
    const { vendorId, params } = action.payload;
    const response = yield call(priceHistoryAPI.getVendorHistory, vendorId, params);
    yield put(actions.fetchVendorPriceHistorySuccess(vendorId, response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch vendor price history';
    yield put(actions.fetchVendorPriceHistoryFailure(msg));
    message.error(msg);
  }
}

function* fetchPriceInflationSaga(action) {
  try {
    const response = yield call(priceHistoryAPI.getInflationReport, action.payload);
    yield put(actions.fetchPriceInflationSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch price inflation report';
    yield put(actions.fetchPriceInflationFailure(msg));
    message.error(msg);
  }
}

export default function* priceHistorySaga() {
  yield takeLatest(types.FETCH_PRODUCT_PRICE_HISTORY_REQUEST, fetchProductPriceHistorySaga);
  yield takeLatest(types.FETCH_VENDOR_PRICE_HISTORY_REQUEST, fetchVendorPriceHistorySaga);
  yield takeLatest(types.FETCH_PRICE_INFLATION_REQUEST, fetchPriceInflationSaga);
}
